const CLICK_EVENTS = new WeakSet<MouseEvent>();

export const recordCarouselControlClickEvent = (event: MouseEvent) => {
  CLICK_EVENTS.add(event);
};

export const isCarouselControlClickEvent = (event: MouseEvent) => {
  return CLICK_EVENTS.has(event);
};
